import { configureStore } from '@reduxjs/toolkit';
import { enableMapSet, enablePatches } from 'immer';
import { unstable_batchedUpdates } from 'react-dom';
import { createReduxHistoryContext } from 'redux-first-history';

import { rootReducer } from '@webapp/account/src/resources/reducers';

import { isDev } from '@webapp/common/lib/const';
import { history as rawHistory } from '@webapp/common/lib/history';

import { listenerMiddleware } from './listener';

enablePatches();
enableMapSet();

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: rawHistory,
    batch: unstable_batchedUpdates,
    savePreviousLocations: 20,
});

export const store = configureStore({
    devTools: isDev,
    reducer: rootReducer(routerReducer),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat([routerMiddleware, listenerMiddleware.middleware]),
});
export const history = createReduxHistory(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

if (document.referrer && !localStorage.getItem('referrer')) {
    localStorage.setItem('referrer', document.referrer);
}
